<template>
  <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">

    <el-row style="padding: 10px 20px;">
      <div class="dash-line" style="padding: 20px 20px;">
        <el-row style="color: #299BFF;">门禁控制器</el-row>
        <el-row style="color: #999;margin-top: 20px;">
          <el-col :span="4">IP: <span style="color:#fff;">{{ portProperties.IP }}</span></el-col>
          <el-col :span="8">状态: <span :style="{color: byIndicatorLightStatus===0? '#F95453' : '#15DEB5'}">{{
              byIndicatorLightStatus === 0 ? '不在线' : '在线'
            }}</span></el-col>
        </el-row>
      </div>
      <div class="dash-line" style="padding: 20px 20px;margin-top: 20px;min-height: 38vh;">
        <el-tabs @tab-click="handleClick" v-if="doorNameList.length > 0" v-model="activeId">
          <el-tab-pane :key="item.id" :label="'门'+item.id+ (item.name?' ('+item.name+')' : '')" :name="item.id"
                       v-for="item in doorNameList"></el-tab-pane>
          <el-row>
            <el-col :lg="8">
              <div @touchstart="controlDvrDoor(1)"  @click="controlDvrDoor(1)" class="controlButton pointer" style="margin-top: 20px">开门</div>
              <div @touchstart="controlDvrDoor(0)" @click="controlDvrDoor(0)" class="controlButton pointer">关门</div>
              <div @touchstart="controlDvrDoor(2)" @click="controlDvrDoor(2)" class="controlButton pointer">常开</div>
              <div @touchstart="controlDvrDoor(3)" @click="controlDvrDoor(3)" class="controlButton pointer">常关</div>
              <div @touchstart="controlDvrDoor(4)" @click="controlDvrDoor(4)" class="controlButton pointer">恢复</div>
              <el-row style="color: #999;margin-top: 20px;">门状态: <span
                style="color:#fff;">{{ doorStatus[activeId - 1] | changeDoorStatus }}开门</span></el-row>
              <el-row style="color: #999;margin-top: 6px;">读卡器状态: <span
                :style="{color: byCardReaderOnlineStatus[activeId]===0? '#F95453' : '#15DEB5'}">
                {{ byCardReaderOnlineStatus[activeId] === 0 ? '掉线' : '在线' }}</span></el-row>
            </el-col>
            <el-col :lg="16">

              <el-date-picker
                @change="formChange"
                end-placeholder="结束日期"
                format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                size="mini"
                start-placeholder="开始日期"
                style="width: 350px; height: 30px;margin: 20px 20px 10px 0"
                type="daterange"
                v-model="date"
                value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <!--      开门记录-->
              <el-row>
                <el-table
                  :data="doorLogList"
                  border
                  class="m-auto"
                  height="24vh"
                  style="width: 100%;">
                  <el-table-column
                    align="center"
                    label="卡号"
                    prop="cardNo">
                    <template slot-scope="scope">
                      <span class="largeContent">{{ scope.row.cardNo ? scope.row.cardNo : '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="用户名"
                    prop="netUser">
                    <template slot-scope="scope">
                      <span class="largeContent">{{ scope.row.netUser ? scope.row.netUser : '-' }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="门编号"
                    prop="doorNo">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="读卡器编号"
                    prop="cardReaderNo">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="开门时间"
                    prop="time">
                  </el-table-column>
                </el-table>
              </el-row>
              <el-pagination
                :current-page="currentPage" :hide-on-single-page="true"
                :page-size="pageSize"
                :small="true"
                :total="doorLogs.length"
                @current-change="pageChange"
                class="mb-1 mt-1 text-center"
                layout="prev, pager, next"
                style="padding-left: 35px;width: 92%;">
              </el-pagination>
            </el-col>
          </el-row>
        </el-tabs>
        <no-data style="margin-top: 10%" v-else></no-data>
      </div>

    </el-row>
  </div>
</template>

<script>
import {getLatestDay} from "@/assets/js/DateFormat";
import {controlDvrDoor, getDoorAcsWorkStatus, getDvrDoorConfig, getDvrDoorLogs} from "@/network/DVR";
import NoData from "@/components/NoData";
import {passwordVerifiers} from "@/network/account";
import {getCookie, setCookie} from "@/utils/common";

export default {
  name: "HKDoor",
  components: {NoData},
  props: ['deviceInfo', 'alarmInfoList'],
  data() {
    return {
      // 开门记录
      logs: [],
      doorLogs: [],
      doorLogList: [],
      portProperties: {},
      activeId: "1",
      doorNum: null, //门编号
      byIndicatorLightStatus: 0, //指示灯状态，0-掉线，1-在线
      doorNameList: [],//门名称
      doorStatus: [], //门状态 1- 休眠，2- 常开状态（对于梯控，表示自由状态），3- 常闭状态（对于梯控，表示禁用状态），4- 普通状态（对于梯控，表示受控状态）
      byCardReaderOnlineStatus: [],//读卡器在线状态，0-不在线，1-在线
      date: '',
      currentPage: 1,
      pageSize: 10,
    }
  },
  watch: {
    activeId: {
      handler(val) {
        this.doorNum = val
        this.doorLogs = this.logs.filter(item => item.doorNo == this.doorNum)
        this.currentPage = 1
        this.currentChangePage()
        console.log(this.doorNum, val, "---门编号--");
      }
    }
  },
  mounted() {
    this.initDoor()
  },
  created() {
    this.date = getLatestDay()
  },
  filters: {
    changeDoorStatus: function (param) {
      switch (param) {
        case 1:
          return '休眠';
        case 2:
          return '常开';
        case 3:
          return '常闭';
        case 4:
          return '普通';
      }
    }
  },
  methods: {
    initDoor() {
      this.portProperties = JSON.parse(this.deviceInfo.portProperties)
      this.getDoorAcsWorkStatus();
    },
    //获取门禁主机工作状态
    getDoorAcsWorkStatus() {
      getDoorAcsWorkStatus("hikvision", this.portProperties.IP, this.portProperties.pwd, this.portProperties.User).then(res => {
        if (res.code === 0) {
          this.byIndicatorLightStatus = 1
          console.log(res, "---门禁控制器--");
          let data = JSON.parse(res.data)
          data.byDoorStatus.forEach((item, index) => {
            if (item !== 0) {
              this.doorStatus.push(item)
              let i = index
              if (index !== 0) {
                i = i + 1
              }
              this.byCardReaderOnlineStatus.push(data.byCardReaderOnlineStatus[i])
            }
          })
          this.doorNameList = new Array(this.doorStatus.length);
          for (let i = 0; i < this.doorStatus.length; i++) {
            this.getDvrDoorConfig(i + 1)
          }
          this.getDvrDoorLogs();
        } else {
          this.byIndicatorLightStatus = 0
        }
      })
    },
    //获取门禁设备日志
    getDvrDoorLogs() {
      getDvrDoorLogs("hikvision", this.portProperties.IP, this.portProperties.pwd, this.portProperties.User, this.date[0], this.date[1]).then(res => {
        console.log(res.data, this.doorNum, "----门记录,门编号---");
        this.logs = res.data
        this.doorLogs = this.logs.filter(item => item.doorNo == this.doorNum)
        this.currentChangePage()
      })
    },
    //获取门参数
    getDvrDoorConfig(channel) {
      getDvrDoorConfig("hikvision", this.portProperties.IP, this.portProperties.pwd, this.portProperties.User, channel).then(res => {
        this.$set(this.doorNameList, channel - 1, {
          id: channel.toString(),
          name: res.data.doorName,
        });
        if (channel === 1) {
          this.doorNum = channel.toString()
        }
        console.log(this.doorNameList, "----门参数---");
      })
    },
    //控制门
    controlDvrDoor(dwStaic) {
      if (getCookie("passwordVerification") === '1') {
        controlDvrDoor("hikvision", this.portProperties.IP, this.portProperties.pwd, this.portProperties.User, this.activeId, dwStaic).then(res => {
          if (res.code === 0) {
            this.$message.success("操作成功!")
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$prompt('请输入系统登录密码确认身份', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
        }).then(({value}) => {
          passwordVerifiers(value).then(res => {
            if (res.data === true) {
              setCookie("passwordVerification", '1', null);
              controlDvrDoor("hikvision", this.portProperties.IP, this.portProperties.pwd, this.portProperties.User, this.activeId, dwStaic).then(res => {
                if (res.code === 0) {
                  this.$message.success("操作成功!")
                } else {
                  this.$message.error(res.msg)
                }
              })
              this.functionDialogVisible = false;
            } else {
              this.$message({
                message: '系统登录密码错误',
                type: 'warning'
              });
              return;
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      }

    },
    // 翻页
    pageChange(page) {
      this.currentPage = page
      this.currentChangePage()
    },
    //分页方法
    currentChangePage() {
      let from = (this.currentPage - 1) * this.pageSize;
      let to = this.currentPage * this.pageSize;
      this.tempList = [];
      this.doorLogList = []
      for (; from < to; from++) {
        if (this.doorLogs[from]) {
          this.doorLogList.push(this.doorLogs[from]);
        }
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    // 日期选择
    formChange() {
      this.getDvrDoorLogs()
    }
  }
}
</script>

<style scoped>
.el-tabs >>> .el-tabs__item.is-top {
  color: #07E6F8;
  padding: 0 10px;
}

.el-tabs >>> .el-tabs__item.is-top.is-active {
  color: #299BFF;
}

.el-tabs >>> .el-tabs__nav-wrap::after {
  background-color: rgba(41, 155, 255, .2);
}

.controlButton {
  padding: 0 15px;
  border-radius: 15px;
  border: 1px solid rgba(41, 155, 255, .5);
  display: inline-block;
  margin-right: 10px;
  margin-top: 20px;
}
</style>
